export default __webpack_public_path__ + "static/media/D0BD677F-FBB1-428F-990A-94549D6813FA_1_105_c.9ed137c4.jpeg";